"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _gatsbyPluginImage = require("gatsby-plugin-image");

var GatsbyImage = function GatsbyImage(props) {
  var image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      rest = (0, _objectWithoutProperties2.default)(props, ["image", "alt"]); // useMemo prevents the element from re-rendering when dealing with SVG images
  // TODO: There might be a better solution for this in the future

  var component = (0, _react.useMemo)(function () {
    var imageObject = (image === null || image === void 0 ? void 0 : image.localFile) && (0, _gatsbyPluginImage.getImage)(image.localFile);

    if (!imageObject && image !== null && image !== void 0 && image.sourceUrl) {
      imageObject = {
        height: (image === null || image === void 0 ? void 0 : image.height) || 0,
        width: (image === null || image === void 0 ? void 0 : image.width) || 0,
        images: {
          fallback: {
            sizes: (image === null || image === void 0 ? void 0 : image.sizes) || '',
            srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || '',
            src: image === null || image === void 0 ? void 0 : image.sourceUrl
          },
          sources: [{
            sizes: (image === null || image === void 0 ? void 0 : image.sizes) || '',
            srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || '',
            type: (image === null || image === void 0 ? void 0 : image.mediaType) || ''
          }]
        },
        layout: 'constrained',
        placeholder: {
          fallback: ''
        }
      };
    }

    return imageObject ? /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
      image: imageObject,
      alt: alt
    })) : null;
  }, [image]);
  return component;
};

var _default = GatsbyImage;
exports.default = _default;